export const manTimePriceComputer = (value: number, manHourlyRate: number) => {
  return (value / 60) * manHourlyRate;
};
